(function () {
  'use strict';

  function initBMPLRadioButtons() {
    const bmplContainer = document.querySelector('.pdp-bmpl');
    if (!bmplContainer) return;

    const options = bmplContainer.querySelectorAll('.pdp-bmpl__option[role="radio"]');
    if (options.length === 0) return;

    function toggleDropdowns(isEnabled) {
      const allDropdowns = bmplContainer.querySelectorAll('.pdp-bmpl__select');
      allDropdowns.forEach(function (dropdown) {
        if (isEnabled) {
          dropdown.disabled = false;
          dropdown.removeAttribute('aria-disabled');
        } else {
          dropdown.disabled = true;
          dropdown.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function selectOption(option) {
      options.forEach(function (opt) {
        opt.classList.remove('pdp-bmpl__option--selected');
        const radio = opt.querySelector('.pdp-bmpl__radio');
        if (radio) {
          radio.classList.remove('pdp-bmpl__radio--selected');
        }
        opt.setAttribute('aria-checked', 'false');
        opt.setAttribute('tabindex', '-1');
      });

      option.classList.add('pdp-bmpl__option--selected');
      const radio = option.querySelector('.pdp-bmpl__radio');
      if (radio) {
        radio.classList.add('pdp-bmpl__radio--selected');
      }
      option.setAttribute('aria-checked', 'true');
      option.setAttribute('tabindex', '0');
      option.focus();

      const hasDropdowns = option.querySelector('.pdp-bmpl__details') !== null;
      toggleDropdowns(hasDropdowns);
    }

    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        selectOption(option);
      });

      option.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(option);
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const currentIndex = Array.from(options).indexOf(option);
          const nextIndex = (currentIndex + 1) % options.length;
          selectOption(options[nextIndex]);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const currentIndex = Array.from(options).indexOf(option);
          const prevIndex = (currentIndex - 1 + options.length) % options.length;
          selectOption(options[prevIndex]);
        }
      });
    });

    options.forEach(function (option) {
      const isSelected = option.classList.contains('pdp-bmpl__option--selected');
      option.setAttribute('tabindex', isSelected ? '0' : '-1');

      if (isSelected) {
        const hasDropdowns = option.querySelector('.pdp-bmpl__details') !== null;
        toggleDropdowns(hasDropdowns);
      }
    });

    const hasSelectedOption = Array.from(options).some(function (opt) {
      return opt.classList.contains('pdp-bmpl__option--selected');
    });

    if (!hasSelectedOption) {
      toggleDropdowns(false);
    }
  }

  function initFrequentlyBoughtCheckboxes() {
    const frequentlyBoughtSection = document.querySelector('.pdp-frequently-bought');
    if (!frequentlyBoughtSection) return;

    const checkboxes = frequentlyBoughtSection.querySelectorAll('.pdp-frequently-bought__checkbox-input');
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {});
    });
  }

  const PRODUCT_FORM_SELECTOR = 'product-form-component';
  const STOCK_VARIANTS_SELECTOR = '[data-stock-variants]';
  const VARIANT_INPUT_SELECTOR = 'input[ref="variantId"], input[name="id"]';
  const QUANTITY_INPUT_SELECTOR = 'input[name="quantity"]';
  const ATC_BUTTON_SELECTOR = 'button[name="add"], [type="submit"][name="add"]';

  const FIXED_MAX_PER_VARIANT = 5;

  let cartPromise = null;
  let cartCache = null;

  function parseJSON(el, fallback = []) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (error) {
      console.warn('[buybox] JSON parse error', error);
      return fallback;
    }
  }

  function getProductForms() {
    return Array.from(document.querySelectorAll(PRODUCT_FORM_SELECTOR));
  }

  function getVariantInput(productForm) {
    return productForm?.querySelector(VARIANT_INPUT_SELECTOR) || null;
  }

  function getQuantityInput(productForm) {
    const drawer = productForm?.closest('#quick-add-drawer-content');
    if (drawer instanceof HTMLElement) {
      const detachedQty =
        drawer.querySelector('.pdp-buybox__row input[name="quantity"]') ||
        drawer.querySelector('quantity-selector-component input[name="quantity"]') ||
        drawer.querySelector('.pdp-buybox__qty input[name="quantity"]');
      if (detachedQty instanceof HTMLInputElement) return detachedQty;
    }
    return productForm?.querySelector(QUANTITY_INPUT_SELECTOR) || null;
  }

  function getAtcButton(productForm) {
    return productForm?.querySelector(ATC_BUTTON_SELECTOR) || null;
  }

  function getStockVariants(productForm) {
    return parseJSON(productForm?.querySelector(STOCK_VARIANTS_SELECTOR), []);
  }

  /**
   * Append Buy More Save More (BMSM) properties to a FormData add-to-cart request.
   * Keeps discount application independent of the BMSM block UI.
   * @param {HTMLElement | null | undefined} productForm
   * @param {FormData} formData
   */
  function appendBmsmProperties(productForm, formData) {
    if (!productForm || !(formData instanceof FormData)) return;
    if (productForm.dataset.bmsmEnabled !== 'true') return;

    const groupId =
      productForm.dataset.bmsmGroupId ||
      (productForm.dataset.productId ? `bmsm-${productForm.dataset.productId}` : `bmsm-${Date.now()}`);

    formData.append('properties[_bmsm_group_id]', groupId);
    formData.append('properties[_bmsm_group_name]', 'Buy More Save More');
    formData.append('properties[_bmsm_buy2]', String(productForm.dataset.bmsmBuy2Discount ?? ''));
    formData.append('properties[_bmsm_buy3]', String(productForm.dataset.bmsmBuy3Discount ?? ''));
    formData.append('properties[_bmsm_buy4]', String(productForm.dataset.bmsmBuy4Discount ?? ''));
    formData.append('properties[_bmsm_buy5]', String(productForm.dataset.bmsmBuy5Discount ?? ''));
  }


  function getBundleOptions(productForm) {
    const productDetails = productForm?.closest('[data-product-details]');
    return productDetails ? productDetails.querySelector('[data-bundle-options]') : null;
  }

  function getBundleFixedVariantIds(bundleOptions) {
    const script = bundleOptions?.querySelector('[data-bundle-fixed-variant-ids]');
    if (!script) return [];

    try {
      const ids = JSON.parse(script.textContent || '[]');
      return Array.isArray(ids) ? ids.map(String).filter(Boolean) : [];
    } catch (error) {
      console.warn('[buybox] bundle fixed variants parse error', error);
      return [];
    }
  }

  function getBundleSelectedVariantIds(bundleOptions) {
    if (!bundleOptions) return [];

    return Array.from(bundleOptions.querySelectorAll('[data-child-product]')).map(function (childProduct) {
      const selectedInput = childProduct.querySelector('[data-child-variant-input]:checked');
      return selectedInput ? String(selectedInput.value) : null;
    });
  }

  function validateBundleOptions(productForm) {
    const bundleOptions = getBundleOptions(productForm);
    if (!bundleOptions) return true;

    let isValid = true;

    bundleOptions.querySelectorAll('[data-child-product]').forEach(function (childProduct) {
      const selectedInput = childProduct.querySelector('[data-child-variant-input]:checked');
      const errorEl = childProduct.querySelector('.pdp-bundle-product__error');

      if (!selectedInput) {
        isValid = false;
        childProduct.classList.add('has-error');

        if (errorEl) {
          errorEl.hidden = false;
        }
      } else {
        childProduct.classList.remove('has-error');

        if (errorEl) {
          errorEl.hidden = true;
        }
      }
    });

    if (!isValid) {
      const errorMessage = 'Bitte wählen Sie alle Bundle-Optionen aus.';
      showAddToCartError(productForm, errorMessage);

      if (productForm.dataset.stickyTriggered === 'true') {
        document.dispatchEvent(
          new CustomEvent('sticky-atc:error', {
            detail: { message: errorMessage }
          })
        );
      }
    }

    return isValid;
  }

  function appendBundleProperties(productForm, formData) {
    const bundleOptions = getBundleOptions(productForm);
    if (!bundleOptions || !(formData instanceof FormData)) return;

    const fixedVariantIds = getBundleFixedVariantIds(bundleOptions);
    const selectedVariantIds = getBundleSelectedVariantIds(bundleOptions).filter(Boolean);
    const childProducts = fixedVariantIds.concat(selectedVariantIds);

    if (!childProducts.length) return;

    formData.set('properties[childProducts]', JSON.stringify(childProducts));
  }

  function getCurrentVariantId(productForm) {
    const input = getVariantInput(productForm);
    if (!input) return null;
    return input.value || input.getAttribute('value') || null;
  }

  function findVariant(productForm, variantId) {
    if (!variantId) return null;
    return getStockVariants(productForm).find((variant) => String(variant.id) === String(variantId)) || null;
  }

  async function getCart(force = false) {
    if (!force && cartCache) return cartCache;
    if (!force && cartPromise) return cartPromise;

    cartPromise = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load cart.js');
        return response.json();
      })
      .then((cart) => {
        cartCache = cart;
        cartPromise = null;
        return cart;
      })
      .catch((error) => {
        console.error('[buybox] cart fetch error', error);
        cartPromise = null;
        return { items: [] };
      });

    return cartPromise;
  }

  const ATC_ADDED_DURATION = 2000;

  function getAddingText() {
    return (typeof Theme !== 'undefined' && Theme.translations && Theme.translations.adding) || 'Wird hinzugefügt...';
  }

  function setAtcButtonAdding(button, isAdding) {
    if (!button) return;

    const label = button.querySelector('.add-to-cart-text__content');

    if (isAdding) {
      window.clearTimeout(button._atcAddedTimer);
      button.classList.remove('is-added');
      if (label) {
        if (button.dataset.atcLabel === undefined) button.dataset.atcLabel = label.textContent;
        label.textContent = getAddingText();
      }
      button.classList.add('is-adding');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      return;
    }

    if (label && button.dataset.atcLabel !== undefined) {
      label.textContent = button.dataset.atcLabel;
      delete button.dataset.atcLabel;
    }
    button.classList.remove('is-adding');
    button.disabled = false;
    button.setAttribute('aria-disabled', 'false');
    button.removeAttribute('aria-busy');
  }

  function showAtcButtonAdded(button) {
    if (!button) return;

    button.classList.add('is-added');
    window.clearTimeout(button._atcAddedTimer);
    button._atcAddedTimer = window.setTimeout(function () {
      button.classList.remove('is-added');
    }, ATC_ADDED_DURATION);
  }

  function getCartSectionIds() {
    const ids = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.getAttribute('data-section-id'))
      .filter(Boolean);

    if (!ids.includes('cart-drawer')) ids.push('cart-drawer');

    return Array.from(new Set(ids));
  }

  function getCartQtyForVariant(cart, variantId) {
    if (!cart?.items?.length || !variantId) return 0;

    return cart.items.reduce((sum, item) => {
      return String(item.variant_id) === String(variantId) ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function getVariantMin(variant) {
    return Math.max(1, Number(variant?.quantity_rule?.min || 1));
  }

  function getTotalLimit(variant) {
    if (!variant) return 0;
    if (!variant.available) return 0;

    const inventoryManaged = variant.inventory_management === 'shopify';
    const denyPolicy = String(variant.inventory_policy || '').trim() === 'deny';
    const inventoryQty = Number(variant.inventory_quantity || 0);

    if (inventoryManaged && denyPolicy) {
      return Math.max(0, Math.min(FIXED_MAX_PER_VARIANT, inventoryQty));
    }

    return FIXED_MAX_PER_VARIANT;
  }

  function getRemainingAddable(totalLimit, cartQty) {
    return Math.max(0, totalLimit - cartQty);
  }

  function setRootQuantityState(productForm, min, max) {
    productForm.dataset.quantityDefault = String(min);
    productForm.dataset.quantityMax = String(max);
  }

  function setInputState(quantityInput, min, totalMax, cartQty, options = {}) {
    quantityInput.min = String(min);
    quantityInput.max = String(totalMax);
    quantityInput.dataset.cartQuantity = '0';
    quantityInput.dataset.realCartQuantity = String(cartQty);

    let value;

    if (options.resetQuantity) {
      value = min;
    } else {
      value = Number(quantityInput.value || min);
      if (Number.isNaN(value)) value = min;
      if (value < min) value = min;
      if (totalMax > 0 && value > totalMax) value = totalMax;
    }

    quantityInput.value = String(value);
    quantityInput.setAttribute('value', String(value));

    if (totalMax <= 0) {
      quantityInput.setAttribute('disabled', 'disabled');
    } else {
      quantityInput.removeAttribute('disabled');
    }
  }

  function syncQuantityComponent(productForm, variantId, cartQty) {
    const quantityInput = getQuantityInput(productForm);
    const quantityComponent = quantityInput?.closest('quantity-selector-component');

    if (!quantityInput || !quantityComponent) return;

    quantityComponent.dataset.variantId = String(variantId || '');
    quantityInput.dataset.cartQuantity = '0';
    quantityInput.dataset.realCartQuantity = String(cartQty);

    const minusButton = quantityComponent.querySelector('[name="minus"]');
    const plusButton = quantityComponent.querySelector('[name="plus"]');

    const currentValue = Number(quantityInput.value || 1);
    const min = Number(quantityInput.min || 1);
    const totalMax = Number(quantityInput.max || 0);

    if (minusButton) {
      const shouldDisableMinus = currentValue <= min || totalMax <= 0;
      minusButton.disabled = shouldDisableMinus;
      minusButton.setAttribute('aria-disabled', String(shouldDisableMinus));
    }

    if (plusButton) {
      const shouldDisablePlus = currentValue >= totalMax || totalMax <= 0;
      plusButton.disabled = shouldDisablePlus;
      plusButton.setAttribute('aria-disabled', String(shouldDisablePlus));
    }
  }

  function updateQtyButtons(productForm, currentValue, min, totalMax) {
    const qtyRoot =
      getQuantityInput(productForm)?.closest('quantity-selector-component, quantity-input, quantity-selector, .quantity, .quantity-selector, .pdp-buybox__qty') ||
      productForm;

    if (!qtyRoot) return;

    const decButtons = qtyRoot.querySelectorAll(
      '[data-quantity-decrease], [name="minus"], [data-action="decrease"], .quantity__button[name="minus"]'
    );

    const incButtons = qtyRoot.querySelectorAll(
      '[data-quantity-increase], [name="plus"], [data-action="increase"], .quantity__button[name="plus"]'
    );

    const disableMinus = currentValue <= min || totalMax <= 0;
    const disablePlus = currentValue >= totalMax || totalMax <= 0;

    decButtons.forEach((button) => {
      button.disabled = disableMinus;
      button.setAttribute('aria-disabled', String(disableMinus));
    });

    incButtons.forEach((button) => {
      button.disabled = disablePlus;
      button.setAttribute('aria-disabled', String(disablePlus));
    });
  }

  function updateAtcButton(productForm, canAdd) {
    const button = getAtcButton(productForm);
    if (!button) return;

    button.disabled = !canAdd;
    button.setAttribute('aria-disabled', String(!canAdd));
  }

  function updateCartCountLabel(productForm, cartQty) {
    const label = productForm.querySelector('[ref="quantityLabelCartCount"]');
    if (!label) return;

    const labelText = label.dataset.inCartLabel || 'in cart';

    if (cartQty > 0) {
      label.classList.remove('hidden');
      label.textContent = `(${cartQty} ${labelText})`;
    } else {
      label.classList.add('hidden');
    }
  }

  function updateSoldPiecesUI(productForm, variantId) {
    if (!productForm || !variantId) return;

    const soldPiecesJson = productForm.querySelector('[data-sold-pieces-variants]');
    const soldPiecesBlock = productForm.querySelector('[data-pdp-sold-pieces]');
    const soldPiecesValue = productForm.querySelector('.pdp-sold-pieces__value');

    if (!soldPiecesJson || !soldPiecesBlock || !soldPiecesValue) return;

    let soldPiecesMap = {};

    try {
      soldPiecesMap = JSON.parse(soldPiecesJson.textContent || '{}');
    } catch (error) {
      console.warn('[buybox] sold pieces json parse error', error);
      return;
    }

    const rawValue = soldPiecesMap[String(variantId)];
    const hasValue = rawValue !== null && rawValue !== undefined && String(rawValue).trim() !== '';
    const nextText = hasValue ? `${rawValue}+` : '';
    const isHiddenNow = soldPiecesBlock.classList.contains('hidden');

    if (soldPiecesValue.textContent !== nextText) {
      soldPiecesValue.textContent = nextText;
    }

    if (hasValue && isHiddenNow) {
      soldPiecesBlock.classList.remove('hidden');
    } else if (!hasValue && !isHiddenNow) {
      soldPiecesBlock.classList.add('hidden');
    }
  }

  async function syncProductForm(productForm, options = {}) {
    if (!productForm) return;

    const variantId = getCurrentVariantId(productForm);
    const variant = findVariant(productForm, variantId);
    const quantityInput = getQuantityInput(productForm);

    if (!variant || !quantityInput) return;

    updateSoldPiecesUI(productForm, variantId);

    const cart = await getCart(Boolean(options.forceCartRefresh));
    const cartQty = getCartQtyForVariant(cart, variantId);

    const min = getVariantMin(variant);
    const totalMax = getTotalLimit(variant);
    const canAdd = totalMax > 0;

    setRootQuantityState(productForm, min, totalMax);
    setInputState(quantityInput, min, totalMax, cartQty, {
      resetQuantity: Boolean(options.resetQuantity)
    });
    syncQuantityComponent(productForm, variantId, cartQty);

    const currentValue = Number(quantityInput.value || min);
    updateQtyButtons(productForm, currentValue, min, totalMax);
    updateAtcButton(productForm, canAdd);
    updateCartCountLabel(productForm, cartQty);
  }

  function showAddToCartError(productForm, message) {
    const errorWrapper = productForm.querySelector('[ref="addToCartTextError"]');
    const liveRegion = productForm.querySelector('[ref="liveRegion"]');

    if (errorWrapper) {
      errorWrapper.classList.remove('hidden');

      let textNode = errorWrapper.querySelector('.product-form-text__error-message');
      if (!textNode) {
        textNode = document.createElement('span');
        textNode.className = 'product-form-text__error-message';
        errorWrapper.appendChild(textNode);
      }

      textNode.textContent = message;
    }

    if (liveRegion) {
      liveRegion.textContent = message;
    }
  }

  function clearAddToCartError(productForm) {
    const errorWrapper = productForm.querySelector('[ref="addToCartTextError"]');
    const liveRegion = productForm.querySelector('[ref="liveRegion"]');

    if (errorWrapper) {
      errorWrapper.classList.add('hidden');

      const textNode = errorWrapper.querySelector('.product-form-text__error-message');
      if (textNode) {
        textNode.textContent = '';
      }
    }

    if (liveRegion) {
      liveRegion.textContent = '';
    }
  }

  function bindQuantityInput(productForm) {
    const input = getQuantityInput(productForm);
    if (!input || input.dataset.buyboxQtyBound === 'true') return;

    function normalizeQuantityValue() {
      const min = Number(input.min || 1);
      const totalMax = Number(input.max || 0);
      let currentValue = Number(input.value || min);

      if (Number.isNaN(currentValue)) currentValue = min;
      if (currentValue < min) currentValue = min;
      if (totalMax > 0 && currentValue > totalMax) currentValue = totalMax;

      input.value = String(currentValue);
      input.setAttribute('value', String(currentValue));

      updateQtyButtons(productForm, currentValue, min, totalMax);
    }

    input.addEventListener('input', function () {
      clearAddToCartError(productForm);
      normalizeQuantityValue();
    });

    input.addEventListener('change', function () {
      clearAddToCartError(productForm);
      normalizeQuantityValue();
    });

    const qtyRoot =
      input.closest('quantity-selector-component, quantity-input, quantity-selector, .quantity, .quantity-selector, .pdp-buybox__qty') ||
      productForm;

    if (qtyRoot && qtyRoot.dataset.buyboxQtyButtonsBound !== 'true') {
      qtyRoot.addEventListener('click', function (event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        const qtyButton = target.closest(
          '[data-quantity-decrease], [data-quantity-increase], [name="minus"], [name="plus"], [data-action="decrease"], [data-action="increase"], .quantity__button'
        );

        if (!qtyButton) return;

        clearAddToCartError(productForm);

        setTimeout(function () {
          normalizeQuantityValue();
        }, 0);
      });

      qtyRoot.dataset.buyboxQtyButtonsBound = 'true';
    }

    input.dataset.buyboxQtyBound = 'true';
  }

  function bindVariantInput(productForm) {
    const variantInput = getVariantInput(productForm);
    if (!variantInput || variantInput.dataset.buyboxVariantBound === 'true') return;

    variantInput.addEventListener('change', function () {
      clearAddToCartError(productForm);
      syncProductForm(productForm, {
        forceCartRefresh: false,
        resetQuantity: true
      });
    });

    const observer = new MutationObserver(function (mutations) {
      const changed = mutations.some((mutation) => mutation.attributeName === 'value');
      if (changed) {
        clearAddToCartError(productForm);
        syncProductForm(productForm, {
          forceCartRefresh: false,
          resetQuantity: true
        });
      }
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    variantInput.dataset.buyboxVariantBound = 'true';
  }

  function animateAddToCartButton(button) {
    if (!button) return;

    const iconContainer = button.querySelector('.icon-container');

    if (document.querySelector('.pdp-modern.second')) {
      button.classList.add('active');

      if (iconContainer) {
        iconContainer.textContent = button.dataset.added;
      }
    }

    setTimeout(() => {
      button.classList.remove('active');

      if (iconContainer) {
        iconContainer.textContent = button.dataset.addToCartCaption;
      }
    }, 3000);
  }

  function bindFormSubmit(productForm) {
    const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || form.dataset.buyboxSubmitBound === 'true') return;

    form.addEventListener(
      'submit',
      async function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        const variantId = getCurrentVariantId(productForm);
        const variant = findVariant(productForm, variantId);
        const quantityInput = getQuantityInput(productForm);
        const submitButton = getAtcButton(productForm);

        if (!variant || !quantityInput) return false;

        clearAddToCartError(productForm);

        if (!validateBundleOptions(productForm)) {
          return false;
        }

        const cart = await getCart(true);
        const cartQty = getCartQtyForVariant(cart, variantId);
        const totalMax = getTotalLimit(variant);
        const requestedQty = Number(quantityInput.value || 1);
        const finalQty = cartQty + requestedQty;

        if (finalQty > totalMax) {
          const allowed = Math.max(0, totalMax - cartQty);

          const errorMessage =
            allowed > 0
              ? `Sie können nur noch ${allowed} weitere Artikel${allowed === 1 ? '' : 's'} dieser Variante hinzufügen.`
              : 'Die ausgewählte quantität kann nicht in den Einkaufswagen hinzugefügen werden';

          showAddToCartError(productForm, errorMessage);

          if (productForm.dataset.stickyTriggered === 'true') {
            document.dispatchEvent(
              new CustomEvent('sticky-atc:error', {
                detail: { message: errorMessage }
              })
            );
          }

          return false;
        }

        const formData = new FormData(form);
        appendBmsmProperties(productForm, formData);
        appendBundleProperties(productForm, formData);

        // Ask /cart/add.js to return the re-rendered mini cart sections in the same response, so
        // the drawer can show the new item without its own follow-up round trips (DESPFY-432).
        const cartSectionIds = getCartSectionIds();
        formData.set('sections', cartSectionIds.join(','));
        formData.set('sections_url', window.location.pathname);

        if (productForm.closest('#quick-add-drawer-content')) {
          const qtyInput = getQuantityInput(productForm);
          if (qtyInput instanceof HTMLInputElement && qtyInput.value) {
            formData.set('quantity', qtyInput.value);
          }
        }

        // "Wird hinzugefügt..." while the request runs; "Hinzugefügt" only once it has succeeded.
        // (is-added used to be set here, so the button claimed "added" before anything was.)
        setAtcButtonAdding(submitButton, true);
        let added = false;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: formData
          });

          let data = null;
          try {
            data = await response.json();
          } catch (e) {
            // Intentionally ignored: data stays null and the caller handles that.
            // A non-JSON body is an expected response here, not a fault.
          }

          if (!response.ok) {
            throw new Error(data?.description || data?.message || 'Unable to add this item to the cart.');
          }

          cartCache = null;
            added = true;
            clearAddToCartError(productForm);

            setAtcButtonAdding(submitButton, false);
            showAtcButtonAdded(submitButton);

            // Lets the sticky add-to-cart bars switch to "added" without waiting for cart:updated,
            // which only fires after the follow-up /cart.js below.
            document.dispatchEvent(
              new CustomEvent('atc:added', { detail: { productForm: productForm, item: data } })
            );

            // Render the returned sections into the drawer and open it straight away. This used
            // to wait for a second /cart.js first, which added a full round trip before the mini
            // cart appeared. The header count is corrected from the real cart just below.
            //
            // source 'product-form-component' is deliberate: product-form.js skips its per-form
            // /cart.js refetch for that source (every product card on the page would otherwise
            // fire one), and cart-icon.js then treats itemCount as the quantity just added.
            if (data?.sections) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  detail: {
                    data: {
                      itemCount: requestedQty,
                      source: 'product-form-component',
                      sections: data.sections
                    }
                  }
                })
              );
            }

            openCartDrawer();

            const updatedCart = await getCart(true);

            updateHeaderCartCount(updatedCart.item_count || 0);

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  addedItem: data,
                  cart: updatedCart
                }
              })
            );

            document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          const errorMessage = error?.message || 'Unable to add this item to the cart.';

          showAddToCartError(productForm, errorMessage);

          if (productForm.dataset.stickyTriggered === 'true') {
            document.dispatchEvent(
              new CustomEvent('sticky-atc:error', {
                detail: { message: errorMessage }
              })
            );
          }
        } finally {
          if (!added) setAtcButtonAdding(submitButton, false);
        }

        return false;
      },
      true
    );

    form.dataset.buyboxSubmitBound = 'true';
  }

  function bindBundleOptions() {
    if (document.documentElement.dataset.buyboxBundleOptionsBound === 'true') return;

    document.addEventListener(
      'change',
      function (event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        const input = target.closest('[data-child-variant-input]');
        if (!input) return;

        const childProduct = input.closest('[data-child-product]');
        if (!childProduct) return;

        const selectedValueEl = childProduct.querySelector('[data-selected-option-value]');
        const errorEl = childProduct.querySelector('.pdp-bundle-product__error');

        if (selectedValueEl) {
          selectedValueEl.textContent = input.dataset.optionValue || '';
        }

        childProduct.classList.remove('has-error');

        if (errorEl) {
          errorEl.hidden = true;
        }
      },
      true
    );

    document.documentElement.dataset.buyboxBundleOptionsBound = 'true';
  }

  function bindVariantPickerEvents() {
    if (document.documentElement.dataset.buyboxVariantPickerBound === 'true') return;

    document.addEventListener(
      'change',
      function (event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        if (target.closest('[data-bundle-options]')) return;

        const insideVariantPicker =
          target.closest('variant-picker') ||
          target.matches('[data-option-value-id]') ||
          target.closest('fieldset');

        if (!insideVariantPicker) return;

        setTimeout(function () {
          syncAllProductForms({
            forceCartRefresh: false,
            resetQuantity: true
          });
        }, 50);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        if (!target.closest('variant-picker')) return;

        setTimeout(function () {
          syncAllProductForms({
            forceCartRefresh: false,
            resetQuantity: true
          });
        }, 50);
      },
      true
    );

    document.documentElement.dataset.buyboxVariantPickerBound = 'true';
  }

  function bindGlobalDomObserver() {
    if (document.documentElement.dataset.buyboxDomObserverBound === 'true') return;

    const observer = new MutationObserver(function () {
      initAllProductForms();
      initBMPLRadioButtons();
      initFrequentlyBoughtCheckboxes();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.documentElement.dataset.buyboxDomObserverBound = 'true';
  }

  function initProductForm(productForm) {
    if (!productForm) return;
    bindQuantityInput(productForm);
    bindVariantInput(productForm);
    bindFormSubmit(productForm);
    syncProductForm(productForm, { forceCartRefresh: false });
  }

  function initAllProductForms() {
    getProductForms().forEach(initProductForm);
  }

  async function syncAllProductForms(options = {}) {
    const productForms = getProductForms();
    await Promise.all(productForms.map((form) => syncProductForm(form, options)));
  }

  function initBuyboxCustom() {
    initBMPLRadioButtons();
    initFrequentlyBoughtCheckboxes();
    bindBundleOptions();
    initAllProductForms();
    bindVariantPickerEvents();
    bindGlobalDomObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyboxCustom);
  } else {
    initBuyboxCustom();
  }

  document.addEventListener('shopify:section:load', function () {
    initBuyboxCustom();
  });

  document.addEventListener("variantUpdated:reinitBuybox", initBuyboxCustom);

  document.addEventListener('cart:refresh', function () {
    syncAllProductForms({ forceCartRefresh: true });
  });

  document.addEventListener('cart:updated', function () {
    syncAllProductForms({ forceCartRefresh: true });
  });

  document.addEventListener('quick-add-drawer:content-updated', function (event) {
    const container = event && event.detail && event.detail.container;
    if (!(container instanceof HTMLElement)) return;
    container.querySelectorAll(PRODUCT_FORM_SELECTOR).forEach(function (el) {
      initProductForm(el);
    });
  });

  document.addEventListener('product:rerender', function () {
    initBuyboxCustom();
  });

  function updateHeaderCartCount(itemCount) {
    const selectors = [
      '[data-cart-count]',
      '[data-cart-icon-count]',
      '.cart-count',
      '.header__cart-count',
      '.header-actions__cart-count',
      '.site-header__cart-count'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = String(itemCount);

        if (itemCount > 0) {
          el.classList.remove('hidden', 'is-hidden');
          el.removeAttribute('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
    });
  }

  function openCartDrawer() {
    // The cart drawer section is fetched on-demand (layout/theme.liquid) rather than always
    // present in the DOM - window.ShopLC.openCartDrawer knows how to load it first if needed.
    // Fall back to the DOM-guessing approach below only if that API isn't available.
    if (window.ShopLC && typeof window.ShopLC.openCartDrawer === 'function') {
      window.ShopLC.openCartDrawer();
      return;
    }

    const cartDrawer =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-drawer');

    if (!cartDrawer) {
      const cartToggle =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('[data-cart-toggle]') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('.header-actions__cart') ||
        document.querySelector('a[href="/cart"]');

      if (cartToggle) {
        cartToggle.click();
      }

      return;
    }

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    if (typeof cartDrawer.show === 'function') {
      cartDrawer.show();
      return;
    }

    cartDrawer.setAttribute('open', '');
    cartDrawer.classList.add('is-active', 'active', 'open');
  }

  if (document.documentElement.dataset.readmoreResizeBound !== 'true') {
    let resizeTimer = null;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // setupItem() itself lives in pdp-accordions.js's own closure, not here, and was never
        // exposed - calling it as a bare identifier threw "setupItem is not defined" on every
        // resize tick wherever this script runs (fired 1,510 times, per session-replay data,
        // concentrated on collection pages where the quick-add drawer loads this same buy-box
        // markup - blocks/_product-card.liquid -> buy-buttons.liquid -> this file). Re-running
        // the whole init is what that file already exposes for exactly this purpose.
        if (typeof window.initPdpAccordions === 'function') {
          window.initPdpAccordions();
        }
      }, 150);
    });

    document.documentElement.dataset.readmoreResizeBound = 'true';
  }

function scrollToElement(element, offset = 0) {
  if (!element) return;

  const top = element.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: top,
    behavior: 'smooth'
  });
}

function handleShowDetailsClick(button) {
  if (!button) return;

  const accordionId = button.dataset.openAccordion || '';
  const scrollSelector = button.dataset.scroll || '';

  let targetItem = null;
  let scrollTarget = null;
  let wasClosed = false;

  if (accordionId) {
    const existingItem = document.getElementById(accordionId);
    if (existingItem) {
      wasClosed = !existingItem.classList.contains('is-open');
    }

    targetItem = window.openPdpAccordionById?.(accordionId) || null;
  }

  if (scrollSelector) {
    scrollTarget = document.querySelector(scrollSelector);
  }

  const finalTarget = scrollTarget || targetItem;
  if (!finalTarget) return;

  if (wasClosed) {
    setTimeout(function () {
      scrollToElement(finalTarget, 180);
    }, 400);
  } else {
    scrollToElement(finalTarget, 180);
  }
}

document.addEventListener('click', function (e) {
  const showDetailsButton = e.target.closest('.js-show-details');
  if (showDetailsButton) {
    handleShowDetailsClick(showDetailsButton);
    return;
  }

  const shareButton = e.target.closest('.share-icon-js');
  if (shareButton) {
    handleShareClick(shareButton);
  }
});

})();
